var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{staticStyle:{"padding-top":"17px","padding-bottom":"29px"},attrs:{"type":"file","id":"attach_file","name":"files"},on:{"change":function($event){return _vm.processFile($event)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }